import React, { Component } from 'react';
import { formatDate } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

var ACTION_LABELS = {
  release_payout: { label: 'Release Payout', icon: 'fa-check', color: '#10B981' },
  refund_buyer: { label: 'Refund Buyer', icon: 'fa-undo', color: '#EF4444' },
  dismiss_reports: { label: 'Dismiss Reports', icon: 'fa-times', color: '#6B7280' },
  remove_listing: { label: 'Remove Listing', icon: 'fa-ban', color: '#EF4444' },
  add_note: { label: 'Add Note', icon: 'fa-sticky-note-o', color: '#D4A843' },
  add_strike: { label: 'Add Strike', icon: 'fa-exclamation-circle', color: '#EF4444' },
  remove_strike: { label: 'Remove Strike', icon: 'fa-trash', color: '#6B7280' },
  suspend_user: { label: 'Suspend User', icon: 'fa-pause-circle', color: '#f59e0b' },
  ban_user: { label: 'Ban User', icon: 'fa-ban', color: '#EF4444' },
  unsuspend_user: { label: 'Lift Suspension', icon: 'fa-check-circle', color: '#10B981' },
  unban_user: { label: 'Lift Ban', icon: 'fa-check-circle', color: '#10B981' },
  update_listing: { label: 'Update Listing', icon: 'fa-pencil', color: '#3B82F6' },
  deactivate_listing: { label: 'Deactivate Listing', icon: 'fa-eye-slash', color: '#f59e0b' },
  reactivate_listing: { label: 'Reactivate Listing', icon: 'fa-eye', color: '#10B981' },
  cancel_order: { label: 'Cancel Order', icon: 'fa-times-circle', color: '#EF4444' },
  partial_refund: { label: 'Partial Refund', icon: 'fa-minus-circle', color: '#f59e0b' },
  force_complete: { label: 'Force Complete', icon: 'fa-forward', color: '#10B981' },
  add_order_note: { label: 'Add Order Note', icon: 'fa-sticky-note-o', color: '#3B82F6' },
  resolve_dispute: { label: 'Resolve Dispute', icon: 'fa-check-square', color: '#8B5CF6' },
  batch_release: { label: 'Batch Release', icon: 'fa-check-double', color: '#10B981' },
  export_payouts: { label: 'Export Payouts', icon: 'fa-download', color: '#3B82F6' },
  flag_message: { label: 'Flag Message', icon: 'fa-flag', color: '#EF4444' },
  close_conversation: { label: 'Close Conversation', icon: 'fa-times-circle', color: '#6B7280' },
  set_config: { label: 'Set Config', icon: 'fa-cog', color: '#3B82F6' },
  delete_config: { label: 'Delete Config', icon: 'fa-trash', color: '#EF4444' },
};

var TARGET_ICONS = {
  user: 'fa-user',
  transaction: 'fa-exchange',
  listing: 'fa-tag',
  dispute: 'fa-exclamation-triangle',
  config: 'fa-cog',
};

class AdminAuditLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: [],
      pagination: { page: 1, limit: 50, total: 0, pages: 0 },
      loading: true,
      filterAction: '',
      filterTargetType: '',
      filterDateFrom: '',
      filterDateTo: '',
    };
    this.fetchLog = this.fetchLog.bind(this);
  }

  componentDidMount() {
    this.fetchLog(1);
  }

  fetchLog(page) {
    var self = this;
    self.setState({ loading: true });
    var params = new URLSearchParams();
    params.append('page', page || 1);
    params.append('limit', 50);
    if (self.state.filterAction) params.append('action', self.state.filterAction);
    if (self.state.filterTargetType) params.append('targetType', self.state.filterTargetType);
    if (self.state.filterDateFrom) params.append('dateFrom', self.state.filterDateFrom);
    if (self.state.filterDateTo) params.append('dateTo', self.state.filterDateTo);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/audit-log?' + params.toString())
      .then(function(data) {
        self.setState({ actions: data.actions || [], pagination: data.pagination, loading: false });
      })
      .catch(function(err) {
        console.log('Failed to fetch audit log:', err);
        self.setState({ loading: false });
      });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var actions = this.state.actions;
    var pagination = this.state.pagination;

    return (
      <div>
        {/* Filter Bar */}
        <div className="tw-rounded-xl tw-p-4 tw-mb-4" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-center">
            <select
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterAction}
              onChange={function(e) { self.setState({ filterAction: e.target.value }, function() { self.fetchLog(1); }); }}
            >
              <option value="">All Actions</option>
              <option value="release_payout">Release Payout</option>
              <option value="refund_buyer">Refund Buyer</option>
              <option value="dismiss_reports">Dismiss Reports</option>
              <option value="remove_listing">Remove Listing</option>
              <option value="add_note">Add Note</option>
              <option value="add_strike">Add Strike</option>
              <option value="remove_strike">Remove Strike</option>
              <option value="suspend_user">Suspend User</option>
              <option value="ban_user">Ban User</option>
              <option value="unsuspend_user">Lift Suspension</option>
              <option value="unban_user">Lift Ban</option>
              <option value="cancel_order">Cancel Order</option>
              <option value="partial_refund">Partial Refund</option>
              <option value="force_complete">Force Complete</option>
              <option value="add_order_note">Add Order Note</option>
              <option value="resolve_dispute">Resolve Dispute</option>
              <option value="batch_release">Batch Release</option>
              <option value="export_payouts">Export Payouts</option>
              <option value="flag_message">Flag Message</option>
              <option value="close_conversation">Close Conversation</option>
              <option value="set_config">Set Config</option>
              <option value="delete_config">Delete Config</option>
            </select>
            <select
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterTargetType}
              onChange={function(e) { self.setState({ filterTargetType: e.target.value }, function() { self.fetchLog(1); }); }}
            >
              <option value="">All Targets</option>
              <option value="user">User</option>
              <option value="transaction">Transaction</option>
              <option value="listing">Listing</option>
              <option value="dispute">Dispute</option>
              <option value="config">Config</option>
            </select>
            <input
              type="date"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterDateFrom}
              onChange={function(e) { self.setState({ filterDateFrom: e.target.value }, function() { self.fetchLog(1); }); }}
              placeholder="From"
            />
            <input
              type="date"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterDateTo}
              onChange={function(e) { self.setState({ filterDateTo: e.target.value }, function() { self.fetchLog(1); }); }}
              placeholder="To"
            />
            {(this.state.filterAction || this.state.filterTargetType || this.state.filterDateFrom || this.state.filterDateTo) && (
              <button
                className="tw-text-xs tw-px-3 tw-py-2.5 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5]"
                onClick={function() { self.setState({ filterAction: '', filterTargetType: '', filterDateFrom: '', filterDateTo: '' }, function() { self.fetchLog(1); }); }}
              >
                <i className="fa fa-times tw-mr-1" />Clear
              </button>
            )}
          </div>
        </div>

        {/* Loading */}
        {this.state.loading && (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading...</span>
            </div>
          </div>
        )}

        {/* Table */}
        {!this.state.loading && (
          <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <div className="tw-overflow-x-auto">
              <table className="tw-w-full tw-text-sm">
                <thead>
                  <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa', borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Date</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Admin</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Action</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Target</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Details</th>
                  </tr>
                </thead>
                <tbody>
                  {actions.map(function(entry) {
                    var info = ACTION_LABELS[entry.action] || { label: entry.action, icon: 'fa-circle', color: '#6B7280' };
                    var targetIcon = TARGET_ICONS[entry.targetType] || 'fa-circle';
                    return (
                      <tr key={entry._id} className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#f9f9f9] dark:hover:tw-bg-[#151515] tw-transition-colors">
                        <td className="tw-px-4 tw-py-3.5 tw-text-[#666] dark:tw-text-[#aaa] tw-whitespace-nowrap">
                          <div className="tw-text-xs">{new Date(entry.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</div>
                          <div className="tw-text-[10px] tw-text-[#999]">{new Date(entry.createdAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</div>
                        </td>
                        <td className="tw-px-4 tw-py-3.5">
                          <div className="tw-flex tw-items-center tw-gap-2">
                            {entry.admin && entry.admin.image ? (
                              <img src={entry.admin.image.startsWith('http') ? entry.admin.image : constants.DOMAIN + '/' + entry.admin.image} alt="" className="tw-w-6 tw-h-6 tw-rounded-full tw-object-cover" />
                            ) : (
                              <div className="tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                                <i className="fa fa-user tw-text-[10px] tw-text-[#ccc]" />
                              </div>
                            )}
                            <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">{entry.admin ? entry.admin.userName : 'System'}</span>
                          </div>
                        </td>
                        <td className="tw-px-4 tw-py-3.5">
                          <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-medium tw-px-2 tw-py-1 tw-rounded-full" style={{ backgroundColor: info.color + '15', color: info.color }}>
                            <i className={'fa ' + info.icon} style={{ fontSize: 10 }} />
                            {info.label}
                          </span>
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-hidden md:tw-table-cell">
                          <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-[#666] dark:tw-text-[#aaa]">
                            <i className={'fa ' + targetIcon} style={{ fontSize: 10 }} />
                            {entry.targetType}
                            {entry.targetId && <span className="tw-text-[10px] tw-text-[#999]">#{String(entry.targetId).slice(-6)}</span>}
                          </span>
                        </td>
                        <td className="tw-px-4 tw-py-3.5 tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-hidden lg:tw-table-cell tw-max-w-xs tw-truncate">
                          {entry.details || '—'}
                        </td>
                      </tr>
                    );
                  })}
                  {actions.length === 0 && (
                    <tr><td colSpan="5" className="tw-px-4 tw-py-12 tw-text-center tw-text-[#999]">
                      <i className="fa fa-history tw-text-3xl tw-mb-2" style={{ display: 'block' }} />No audit log entries found
                    </td></tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            {pagination.pages > 1 && (
              <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3" style={{ borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                <span className="tw-text-xs tw-text-[#999]">Showing {((pagination.page - 1) * pagination.limit) + 1}–{Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total}</span>
                <div className="tw-flex tw-gap-1">
                  <button className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40" disabled={pagination.page <= 1} onClick={function() { self.fetchLog(pagination.page - 1); }}>Prev</button>
                  <button className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40" disabled={pagination.page >= pagination.pages} onClick={function() { self.fetchLog(pagination.page + 1); }}>Next</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AdminAuditLog;
